import React from 'react';
import Modal from "../molecules/Modal"
import QRCode from "qrcode.react";

const QRModal = (props) => {
    return(
        <Modal
            show={props.show}
            onHide={props.onHide}
            title={"Pembayaran QRIS"}
            size={"sm"}
            bodyClassName="py-4 text-center"
            buttons
        >
            <p> Silahkan lakukan pembayaran dengan scan QR code dibawah ini </p>
            <QRCode
                size={156}
                value={props.qrCode}/>
        </Modal>
    );
};

export default QRModal;
